import { multiplyWithFactor } from "@pentacode/openapi";
import { hour } from "../time/consts";
import { dateAdd, parseDateString } from "./date.util";
export function parseTime(date, time) {
    if (!date || !time) {
        return null;
    }
    if (typeof date === "string") {
        date = parseDateString(date);
    }
    if (!date) {
        return null;
    }
    const [hourString, minuteString] = time.split(":");
    const hours = parseInt(hourString);
    const minutes = parseInt(minuteString);
    date = new Date(date);
    date.setHours(hours);
    date.setMinutes(minutes);
    return date;
}
export function parseTimes(date, start, end) {
    const startDate = parseTime(date, start);
    const endDate = parseTime(end && start && start.slice(0, 5) > end.slice(0, 5) ? dateAdd(date, { days: 1 }) : date, end);
    return [startDate, endDate];
}
export function toTimeString(date) {
    if (!date) {
        return "";
    }
    if (typeof date === "string") {
        date = new Date(date);
    }
    return `${date.getHours().toString().padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}`;
}
export function toDurationString(dur, trimLeadingZero = false) {
    if (!dur) {
        return trimLeadingZero ? "0:00" : "00:00";
    }
    const absDur = Math.abs(dur);
    // we do this in case we round a minute up to another full hour
    const minutes = Math.round(absDur * 60);
    const hours = Math.floor(minutes / 60);
    const minutesRest = minutes % 60;
    if (hours === 0 && minutesRest === 0) {
        return trimLeadingZero ? "0:00" : "00:00";
    }
    let hoursStr = hours.toString();
    if (!trimLeadingZero) {
        hoursStr = hoursStr.padStart(2, "0");
    }
    const minutesStr = minutesRest.toString().padStart(2, "0");
    return `${dur < 0 ? "-" : ""}${hoursStr}:${minutesStr}`;
}
export function parseDurationString(str) {
    if (!str) {
        return 0;
    }
    const [hours, minutes] = str.split(":");
    return (parseInt(hours) + parseInt(minutes) / 60);
}
export function formatTimeDistance(date) {
    date = new Date(date);
    const seconds = (Date.now() - date.getTime()) / 1000;
    const minutes = seconds / 60;
    const hours = minutes / 60;
    const days = hours / 24;
    const prefix = seconds < 0 ? "in" : "vor";
    if (Math.abs(days) > 2) {
        return `${prefix} ${Math.abs(Math.floor(days))} Tagen`;
    }
    else if (Math.abs(hours) > 2) {
        return `${prefix} ${Math.abs(Math.floor(hours))} Std`;
    }
    else {
        return `${prefix} ${Math.abs(Math.floor(minutes))} Min`;
    }
}
export function formatTimeDistanceShort(date, now = new Date()) {
    const hours = Math.max(0, (now.getTime() - new Date(date).getTime()) / hour);
    const days = hours / 24;
    if (hours < 1) {
        return "vor <1h";
    }
    else if (days > 2) {
        return `vor ${Math.floor(days)}T`;
    }
    else {
        return `vor ${Math.floor(hours)}h`;
    }
}
export function hoursToMilliseconds(hours) {
    return multiplyWithFactor(hour, hours);
}
export function getTimeBetweenDates(start, end) {
    return (end.getTime() - start.getTime());
}
//# sourceMappingURL=time.util.js.map